/*
 * ELDR Food Hours — cart-level gate.
 *
 * Runs on every page (loaded once, sitewide, via the cart drawer overlay
 * group) plus the cart page itself. Checks the REAL cart contents
 * (/cart.js) against the same food-handle list food-hours.js uses, and
 * only acts when BOTH are true:
 *   1. the cart contains at least one food/drink line item, AND
 *   2. ELDR food ordering is currently closed.
 * A cart containing supplements only is never touched, at any hour.
 *
 * When both are true: disables every checkout button on the page
 * (button[type="submit"][name="checkout"] — the same selector used by
 * both the cart page and the cart drawer) and shows a plain-language
 * notice explaining why, right above it.
 *
 * Honest limitation, stated in code as well as in the project notes: this
 * is a client-side check. It stops the normal "Checkout" button, but it
 * cannot intercept Shopify's own dynamic accelerated-checkout buttons
 * (Shop Pay / PayPal / Google Pay, rendered via
 * content_for_additional_checkout_buttons) — those are Shopify-controlled
 * elements outside this theme's DOM control. True enforcement against
 * every path requires a Shopify Function (cart/checkout validation), which
 * is a separate project — see the food-ordering-hours implementation notes.
 *
 * Does not touch sections/cart-drawer.liquid, sections/main-cart.liquid,
 * theme.js, or any checkout code — purely additive and external.
 */
(function () {
  if (!window.ELDRFoodHours) return;
  // This script tag legitimately appears twice on the cart page (once from
  // templates/cart.json, once from the sitewide cart-drawer overlay group)
  // — only the first copy should run.
  if (window.__eldrFoodCartGateInitialized) return;
  window.__eldrFoodCartGateInitialized = true;

  var NOTICE_CLASS = 'eldr-food-cart-notice';
  var CHECKOUT_SELECTOR = 'button[type="submit"][name="checkout"]';

  function buildNotice() {
    var el = document.createElement('p');
    el.className = NOTICE_CLASS;
    el.innerHTML =
      '<span class="' + NOTICE_CLASS + '__label">Online Ordering Closed</span>' +
      '<span class="' + NOTICE_CLASS + '__body">Your cart includes ELDR food or drink items. ' +
      'Food/drink pickup ordering is available daily, 10 AM–5 PM Pacific Time. ' +
      'Remove those items to check out now, or come back during open hours.</span>';
    return el;
  }

  function applyGate(blocked) {
    var buttons = document.querySelectorAll(CHECKOUT_SELECTOR);
    buttons.forEach(function (button) {
      var container = button.closest('form') || button.parentElement;
      var existingNotice = container ? container.querySelector('.' + NOTICE_CLASS) : null;

      if (!blocked) {
        if (button.dataset.eldrClosedByFoodCart === 'true') {
          button.disabled = button.dataset.eldrWasDisabled === 'true';
          delete button.dataset.eldrClosedByFoodCart;
        }
        button.classList.remove('eldr-food-cart-disabled');
        if (existingNotice) existingNotice.remove();
        return;
      }

      if (button.dataset.eldrClosedByFoodCart !== 'true') {
        button.dataset.eldrWasDisabled = button.disabled ? 'true' : 'false';
      }
      button.dataset.eldrClosedByFoodCart = 'true';
      button.disabled = true;
      button.classList.add('eldr-food-cart-disabled');
      if (container && !existingNotice) {
        container.insertAdjacentElement('beforebegin', buildNotice());
      }
    });
  }

  function cartHasFoodItem(cart) {
    return cart.items.some(function (item) {
      return window.ELDRFoodHours.isFoodHandle(item.handle);
    });
  }

  function check() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var blocked = !window.ELDRFoodHours.isOpen() && cartHasFoodItem(cart);
        applyGate(blocked);
      })
      .catch(function () {
        /* Network hiccup — leave checkout untouched rather than block
           purchases on a failed fetch. */
      });
  }

  check();
  setInterval(check, 20000);

  if (window.theme && window.theme.pubsub && window.theme.pubsub.PUB_SUB_EVENTS) {
    window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, check);
  }

  document.addEventListener('cart:updated', check);
})();
